import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";
import Badges from "components/UI/Badges/Badges";

import selectedIcon from "assets/images/selectdeadline.svg";
import selectedIconBlue from "assets/images/selectdeadline-blue.svg";

import "./ExecutorTypeSelector.scss";

const ExecutorTypeSelector = observer(({ store }) => {
  const navigate = useNavigate();
  const { market, currentCalculator, calculators } = store;

  if (!market.executorTypes || market.executorTypes.length <= 1) {
    return null;
  }

  const getCurrentExecutorTypeId = () => {
    const currentPath = currentCalculator.mode.path;
    const matchingType = market.executorTypes.find((type) => {
      return calculators.some(
        (calc) => calc.mode.path === currentPath && 
        market.executorTypes.indexOf(type) === calculators.indexOf(calc) % market.executorTypes.length
      );
    });
    return matchingType?.id || market.executorTypes[0]?.id;
  };

  const currentExecutorTypeId = getCurrentExecutorTypeId();
  const isYandex = market.isSeo;

  const handleSelectExecutorType = (executorTypeId) => {
    const executorTypeIndex = market.executorTypes.findIndex((type) => type.id === executorTypeId);

    if (executorTypeIndex === -1) return;

    const targetCalculatorIndex = calculators.findIndex((calc, index) => {return index % market.executorTypes.length === executorTypeIndex;});

    if (targetCalculatorIndex !== -1 && targetCalculatorIndex !== store.selectedCalculatorIndex) {
      store.selectCalculator(targetCalculatorIndex);
      navigate(calculators[targetCalculatorIndex].mode.path);
    }
  };

  return (
    <div className="executor-type-selector">
      {market.executorTypes.map((type) => {
        const isActive = currentExecutorTypeId === type.id;
        const isBotsActive = isActive && type.id === "bots";
        const shouldUseBlueStyle = isYandex && isBotsActive;

        return (
          <div key={type.id} className={`executor-type-selector__tabs ${store.market.isSeo ? "other-colors" : ""}`}>
            <ButtonWithIcon
              className={`executor-type-selector__tab ${isActive ? "active" : ""} ${shouldUseBlueStyle ? "active--blue" : ""} ${store.market.isSeo ? "other-colors" : ""}`}
              title={
                <h3>
                  {type.title}{" "}
                  {type.hasPrice && <span className={`has-price ${shouldUseBlueStyle ? "has-price--blue" : ""}`}>{type.hasPrice}</span>}
                </h3>
              }
              icon={isActive ? (shouldUseBlueStyle ? selectedIconBlue : selectedIcon) : ""}
              onClick={() => handleSelectExecutorType(type.id)}
              aria-label={`Выбрать тип исполнителя: ${type.title}`}
              target="_self"
            />
            {!shouldUseBlueStyle && type.badge && <Badges status="дешевле" />}
          </div>
        );
      })}
    </div>
  );
});

export default ExecutorTypeSelector;